import React, { useState, useEffect, useContext } from 'react';
import {
  calendarStyle,
  searchStyle,
  issueStatusFilterState,
  IssueTrackerListColumns,
} from './helper/helper';
import loaderContext from '../../context/loader/LoaderContext';

import { t } from 'i18next';
import {
  Calendar,
  PrimaryButton,
  SearchBox,
  TextField,
  TooltipHost,
  defaultCalendarStrings,
} from '@fluentui/react';
import Moment from 'moment';
import userContext from '../../context/users/UserContext';
import ListViewV3 from '../../components/ListViewV3/ListViewV3';
import toastContext from '../../context/toast/ToastContext';
import CustomToolTipHost from '../../components/CustomToolTipHost/CustomToolTipHost';
import { getSearchedAuditLogList, getSearchIssueStatusList, updateAllIssueStatus, updateIssueStatus } from '../../service/AuditLogService';
import { TOAST_TYPE } from '../../constants/Constants';

const status_code_map = [
  'Success', 
  'Failed', 
  'Warning'
];

const IssueTrackerListView = ({}) => {
  const [selectedRow, setSelectedRow] = useState(0);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [dataQueryState, setDataQueryState] = useState({});
  const { showToastv2 } = useContext(toastContext);
  const [issueStatusList, setIssueStatusList] = useState([]);
  const [activeDataQuery, setActiveDataQuery] = useState([]);

  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: '',
    sortFieldValue: '',
    sortDir: false,
    selected: false,
  });
  const [issueStatusFilterObj, setIssueStatusFilterObj] = useState(
    issueStatusFilterState
  );
  const [displayListAppliedFilter, setDisplayListAppliedFilter] = useState([]);

  const formatDate = (date) => {
    return Moment(date).format('DD-MMM-YYYY');
  };

  function updateRow(value, id) {
    let newIndex = -1;
    let newData = dataQueryState?.data?.rows.filter((row, index) => {
      if (row.id == id) {
        newIndex = index;
        return true;
      }
      return false;
    });  
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState
      };
      if(newValue.data.rows[newIndex] != null){
        newValue.data.rows[newIndex].status = value; 
      }
      return newValue;
    });
  }

  const updateAction = async(value, id) =>{
    //console.log("values to be updated", value, id);
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await updateIssueStatus(id, value);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        const updatedItem = response.data.data;
        // ReloadRow(updatedItem, cell.row.index);
        updateRow(value, id);
        showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
      } else if (response.data.result === "FAILURE") {
        showToastv2(TOAST_TYPE.SUSPECT, response.data.message);
      } else {
        showToastv2(TOAST_TYPE.ERROR, "Some error occurred!");
      }
      setLoaderRunning(false);
    } catch (e) {
      console.error("Error refreshing queue item:", e);
      setLoaderRunning(false);
    }
  }

  const fetchData = async (options) => {
    // let page = options.pageIndex;
    // let pageSize = options.pageSize;
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      issueStatusSearch: {
        issueStatusFrom:
          issueStatusFilterObj.startDateObj == null
            ? null
            : formatDate(issueStatusFilterObj.startDateObj),
        issueStatusTo:
          issueStatusFilterObj.endDateObj == null
            ? null
            : formatDate(issueStatusFilterObj.endDateObj),
        patientId:
          issueStatusFilterObj.patientIdObj == null ||
          issueStatusFilterObj.patientIdObj == ""
            ? null
            : issueStatusFilterObj.patientIdObj,
        status: issueStatusFilterObj.statusObj,
        studyId : filterObj.filterInput,
        workFlowName:
          issueStatusFilterObj.workFlowNameObj == null ||
          issueStatusFilterObj.workFlowNameObj == ""
            ? null
            : issueStatusFilterObj.workFlowNameObj,
        issueStatuaPage: options.page,
        pageSize: 50,
      },
    };
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await getSearchIssueStatusList(body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        const results = response.data.data.results.searchResults;
        setIssueStatusList(results);
        // setOrchestratorUrl(response.data.data.orchestratorUrl);
        const pageSize = response.data.data.results.pageSize;
        const totalElement = response.data.data.results.totalRecords;
        data = results;
        pageCount = Math.ceil(totalElement / pageSize);
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleUserClick = (row) => {
    console.log('--- This row clicked ----', row);
    setSelectedRow(row.index);
  };

  const handleClearFilter = () => {
    console.log('---- Clear Filter Clicked ----');
    setIssueStatusFilterObj(issueStatusFilterState);
    setDisplayListAppliedFilter([]);
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = null;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const columns = IssueTrackerListColumns(null, updateAction);

  const removeBadgeFromFilter = (toBeRemoveObj) => {
    setIssueStatusFilterObj((currentIssueStatusFilterObj) => {
      const updateIssueStatusFilterObj = { ...currentIssueStatusFilterObj };

      if (updateIssueStatusFilterObj.hasOwnProperty(toBeRemoveObj.key)) {
        updateIssueStatusFilterObj[toBeRemoveObj.key] = null;
      } else {
        console.error(
          `Key "${toBeRemoveObj.key}" does not exist in orchestratorInitialState.`
        );
      }
      return updateIssueStatusFilterObj;
    });

    setDisplayListAppliedFilter((current) =>
      current.filter((item) => item.label !== toBeRemoveObj.label)
    );

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });

    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  const handleApplyClick = (filterValue) => {
    if (filterValue != undefined) filterValue = filterValue.trim();
    const transformedArray = Object.keys(issueStatusFilterObj)
      .map((key) => ({ key, label: issueStatusFilterObj[key] }))
      .filter((item) => item.label !== null);
    console.log('--- Handle Apply Click ---', transformedArray);

    setDisplayListAppliedFilter(transformedArray);

    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        if (filterValue != null) {
          newItem.filterInput = filterValue;
        }
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  useEffect(() => {
    console.log('Active Query', activeDataQuery);
    if (activeDataQuery != undefined && activeDataQuery.data != undefined) {
      setIssueStatusList(activeDataQuery?.data?.rows);
    }
  }, [activeDataQuery]);

  const filterList = (searchInput) => {
    console.log('--- Filter function TODO ---');
  };

  // update all failed status to warning, to stop the alerts.
  const changeAllStatus = async () => {
    try {
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await updateAllIssueStatus();
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        showToastv2(TOAST_TYPE.SUCCESS, t("issue-tracker-logs.success-message-all"));
        activeDataQuery.refetch();
      } else {
        setLoaderRunning(false);
        showToastv2(TOAST_TYPE.ERROR, t("issue-tracker-logs.failure-message-all"));
      }
    } catch (e) {
      setLoaderRunning(false);
      showToastv2(TOAST_TYPE.ERROR, t("issue-tracker-logs.failure-message-all"));
    }
  };

  // const downloadOrchestratorCSV = async () => {
  //   const body = {
  //     orchestratorLogsSearch: {
  //       jobId:
  //         orchestratorFilterObj.jobIdObj === null
  //           ? null
  //           : orchestratorFilterObj.jobIdObj,
  //       orchestratorLogsFrom:
  //         orchestratorFilterObj.startDateObj === null
  //           ? null
  //           : formatDate(orchestratorFilterObj.startDateObj),
  //       orchestratorLogsTo:
  //         orchestratorFilterObj.endDateObj === null
  //           ? null
  //           : formatDate(orchestratorFilterObj.endDateObj),
  //       patientId:
  //         orchestratorFilterObj.patientIdObj === null ||
  //         orchestratorFilterObj.patientIdObj === ''
  //           ? null
  //           : orchestratorFilterObj.patientIdObj,
  //       status: (function () {
  //         if (
  //           orchestratorFilterObj.status === null ||
  //           orchestratorFilterObj.status === ''
  //         ) {
  //           return null;
  //         }

  //         for (let i = 0; i < status_code_map.length; i++) {
  //           if (status_code_map[i] == orchestratorFilterObj.status) {
  //             return i + 1;
  //           }
  //         }
  //         return null;
  //       })(),
  //       StudyId:
  //         filterObj.filterInput === null || filterObj.filterInput === ''
  //           ? null
  //           : filterObj.filterInput,
  //       orchestratorLogsPage: paginationObj.pageIndex,
  //       pageSize: 50,
  //     },
  //   };

  //   try {
  //     setLoaderRunning(true);
  //     ref.current.continuousStart();
  //     console.log('--- Orchestrator Log download started ----');
  //     console.log(body);
  //     const response = await downloadOrchestratorCSVService(body);

  //     if (response.status === 200 && response.data.result === 'SUCCESS') {
  //       setLoaderRunning(false);
  //       showToastv2(TOAST_TYPE.SUCCESS, t('issue-tracker.success-message'));
  //     } else {
  //       setLoaderRunning(false);
  //       showToastv2(TOAST_TYPE.ERROR, t('issue-tracker.failure-message'));
  //     }
  //   } catch (e) {
  //     setLoaderRunning(false);
  //     showToastv2(TOAST_TYPE.ERROR, t('issue-tracker.failure-message'));
  //   }
  // };

  const buttonsTopBar = [
    {
      key: '1',
      button: (
        <div
          className="add-button-list-view"
          onClick={() => {
            changeAllStatus(); // change failed cases to warning
          }}
        >
          {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
          <PrimaryButton
            text={t('button.mute-alerts')}
            className={
              'common-default-active-button list-view-top-buttons-styles'
            }
            disabled={activeDataQuery?.data?.rows?.length > 0 ? false : true}
          />
        </div>
      ),
    },
    {
      key: '2',
      button: (
        <div
          className="add-button-list-view"
          onClick={() => {
           // downloadOrchestratorCSV();
          }}
        >
          {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
          <PrimaryButton
            text={t('button.export-issue-status-list')}
            className={
              'common-default-active-button list-view-top-buttons-styles'
            }
            // disabled={activeDataQuery?.data?.rows?.length > 0 ? false : true}
            disabled = {true}
          />
        </div>
      ),
    },
    {
      key: '3',
      button: (
        <div
          className="add-button-list-view"
          onClick={() => {
            activeDataQuery.refetch();
          }}
        >
          {/* <AddButton  text={t("supervisor.add-supervisor")} /> */}
          <PrimaryButton
            iconProps={{
              iconName: 'Refresh',
              cursor: 'pointer',
            }}
            text={t('button.refresh')}
            className={
              'common-default-active-button list-view-top-buttons-styles'
            }
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        sortDropdownOptions={[]}
        showSideBySide={false}
        fetchData={fetchData}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        paginationObj={paginationObj}
        setActiveDataQuery={setActiveDataQuery}
        uniqueKey={'issueStatusLogs'}
        selectedRow={selectedRow}
        fullLength={true}
        setDataQueryState={setDataQueryState}
        dataQueryState={dataQueryState}
        tabHeaderPresent={true}
        placeholder={'Study Id'}
        selectedRowComponent={
          <SelectedRowComponent
          issueTrackerListDetails={issueStatusList[selectedRow]}
            displayListAppliedFilter={displayListAppliedFilter}
          />
        }
        enhancedFilter={true}
        showSort={false}
        handleApplyClick={handleApplyClick}
        displayListAppliedFilter={displayListAppliedFilter}
        filterList={filterList}
        handleClearFilter={handleClearFilter}
        removeBadgeFromFilter={removeBadgeFromFilter}
        filterPopUpComponent={
          <FilterPopUpComponent
            issueStatusFilterObj={issueStatusFilterObj}
            setIssueStatusFilterObj={setIssueStatusFilterObj}
          />
        }
        pointer={false}
      />
    </>
  );
};

export default IssueTrackerListView;

const SelectedRowComponent = ({
  issueTrackerListDetails,
  displayListAppliedFilter,
}) => {
  const { getConsistentDateFormat } = useContext(userContext);

  if (issueTrackerListDetails == undefined) {
    return (
      displayListAppliedFilter.length === 0 && (
        <>
          <div className="list-view-no-details-found">
            <p className="study-list-no-data-txt"></p>
          </div>
        </>
      )
    );
  }

  return (
    <>
      <div className="tab-section">
        <section className="sectionA">
          <p
            style={{
              fontSize: '20px',
              fontWeight: '600',
              padding: '0px 8px',
              margin: '10px 0px',
            }}
          >
            {t('issue-tracker.orchestrator-details')}
          </p>
        </section>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">
                {t('audit-logs.audit-time-stamp')}
              </div>
              <div className="form-mt-10">
                {issueTrackerListDetails.username}
              </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">
                {t('audit-logs.audit-time-stamp')}
              </div>
              <div className="form-mt-10">
                {getConsistentDateFormat(
                  issueTrackerListDetails.auditTimestamp
                )}
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: '20px' }}>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t('audit-logs.new-value')}</div>
              <div className="form-mt-10">
                {issueTrackerListDetails.newValue == ''
                  ? '-'
                  : issueTrackerListDetails.newValue}
              </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t('user.username')}</div>
              <div className="form-mt-10">
                {!issueTrackerListDetails.entityId ||
                issueTrackerListDetails.entityId == ''
                  ? '-'
                  : issueTrackerListDetails.entityId}
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: '20px' }}>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t('audit-logs.old-value')}</div>
              <div className="form-mt-10">
                {issueTrackerListDetails.oldValue == ''
                  ? '-'
                  : issueTrackerListDetails.oldValue}
              </div>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t('audit-logs.ip')}</div>
              <div className="form-mt-10">
                {issueTrackerListDetails.remoteIPAddress}
              </div>
            </div>
          </div>
          <div className="ms-Grid-row" style={{ marginTop: '20px' }}>
            <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
              <div className="form-heading">{t('audit-logs.action')}</div>
              <div className="form-mt-10">{issueTrackerListDetails.action}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FilterPopUpComponent = ({
  issueStatusFilterObj,
  setIssueStatusFilterObj,
}) => {
  const [statusList, setStatusList] = useState(status_code_map);

  const filterList = (searchInput) => {
    if (searchInput != null && searchInput != undefined)
      searchInput = searchInput.trim();
    let searchValue = searchInput.toLowerCase();

    if (searchValue !== '') {
      console.log(searchValue);
      const filteredData = status_code_map.filter((item) => {
        return item.toLowerCase().includes(searchValue);
      });
      setStatusList(filteredData);
    } else {
      // If the search input is empty, revert to the original list
      setStatusList(status_code_map);
    }
  };

  const customToolTipClassName = {
    root: 'audit-logs-user-action-text',
  };

  const formattedDate = (date) => {
    return date
      .toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
      .replace(/ /g, '-');
  };

  const dropDownStyle = {
    dropdown: {
      width: '100%',
    },
    dropdownItemSelected: {
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: '600',
    },
    dropdownItemsWrapper: {
      maxHeight: '300px',
    },
    dropdownItem: {
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: '600',
      color: 'white',
    },
  };

  return (
    <div style={{ display: 'flex' }}>
      {/* <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          {t('issue-tracker.status')}
        </span>
        <SearchBox
          placeholder={t('button.search')}
          styles={searchStyle}
          onClear={(ev) => {
            // console.log("Custom onClear Called");
          }}
          onChange={(ev, newValue) => {
            console.log('--- Chaining', newValue);
            filterList(newValue);
          }}
        />
        <div className="modal-scroll study-list-filter-section">
          <ul className="upload-date-ul ">
            {statusList != undefined &&
              statusList.length > 0 &&
              Array.from(statusList).map((item, index) => {
                return (
                  <li
                    onClick={() => {
                      setIssueStatusFilterObj({
                        ...issueStatusFilterObj,
                        status: item,
                      });
                    }}
                    className={`upload-date-li ${
                      issueStatusFilterObj.status == item
                        ? 'study-list-active-li'
                        : ''
                    }`}
                    key={index}
                  >
                    <CustomToolTipHost
                      styles={customToolTipClassName}
                      content={item}
                      id={'tooltip_' + index}
                    >
                      {item}
                    </CustomToolTipHost>
                  </li>
                );
              })}
          </ul>
          {issueStatusFilterObj.length == 0 && (
            <div className="list-popup-no-result-message">
              {t('search-message.no-result')}
            </div>
          )}
        </div>
      </div>
      <div className="filter-section-seperator"></div> */}
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          {t('issue-tracker-logs.issue-tracker-from')}
        </span>
        <div className="modal-scroll study-list-filter-section-without-search">
          <ul
            className="upload-date-ul"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Calendar
              showMonthPickerAsOverlay={true}
              placeholder={t('placeholder.select-date')}
              ariaLabel="Select a date"
              // DatePicker uses English strings by default. For localized apps, you must override this prop.
              styles={calendarStyle}
              showGoToToday={false}
              strings={defaultCalendarStrings}
              onSelectDate={(date) =>
                setIssueStatusFilterObj({
                  ...issueStatusFilterObj,
                  startDateObj: formattedDate(date),
                })
              }
            />
          </ul>
        </div>
      </div>

      <div className="filter-section-seperator"></div>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          {t('issue-tracker-logs.issue-tracker-to')}
        </span>
        <div className="modal-scroll study-list-filter-section-without-search">
          <ul
            className="upload-date-ul"
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Calendar
              showMonthPickerAsOverlay={true}
              placeholder={t('placeholder.select-date')}
              ariaLabel="Select a date"
              // DatePicker uses English strings by default. For localized apps, you must override this prop.
              styles={calendarStyle}
              showGoToToday={false}
              //strings={defaultCalendarStrings}
              onSelectDate={(date) =>
                setIssueStatusFilterObj({
                  ...issueStatusFilterObj,
                  endDateObj: formattedDate(date),
                })
              }
            />
          </ul>
        </div>
      </div>
      <div className="filter-section-seperator"></div>
      <div
        className="study-start-date-filter-section align-filter-section"
        style={{ width: '15%' }}
      >
        <span className="filter-section-text">
          {t('issue-tracker-logs.patient-id')}
        </span>
        <TextField
          name={t('issue-tracker-logs.patient-id')}
          placeholder={t('placeholder.search')}
          value={issueStatusFilterObj.patientIdObj}
          onChange={(ev) => {
            setIssueStatusFilterObj({
              ...issueStatusFilterObj,
              patientIdObj: ev.target.value,
            });
          }}
          styles={{ backgroundColor: '#2e3033' }}
        />
        <span className="filter-section-text">
          {t('issue-tracker-logs.work-flow-name')}
        </span>
        <TextField
          name={t('issue-tracker-logs.work-flow-name')}
          placeholder={t('placeholder.search')}
          value={issueStatusFilterObj.workFlowNameObj}
          onChange={(ev) => {
            setIssueStatusFilterObj({
              ...issueStatusFilterObj,
              workFlowNameObj: ev.target.value,
            });
          }}
          styles={{ backgroundColor: '#2e3033' }}
        />
      </div>
    </div>
  );
};
